const handler = tracker => ({
  trackActiveProjectsTab: metadata => {
    tracker().trackEvent("Ha abierto la pestaña de proyectos activos", metadata)
  }
})

export default handler